import { render, staticRenderFns } from "./Periodicidade.vue?vue&type=template&id=eb34f1de"
import script from "./Periodicidade.vue?vue&type=script&lang=js"
export * from "./Periodicidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports